import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import FormLine from "../../Misc/FormLine";

import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";

import timesheetRefactorInData from "./timesheetRefactorInData";

import DtPicker from "../../Misc/DtPicker";
import ElasticInput from "../../Misc/ElasticInput";
import TimesheetTable from "./TimesheetTable";
import StaffPicker from "../../Misc/StaffPicker";
import TimePeriodPicker from "../../Misc/TimePeriodPicker";

export default class Timesheet extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      notFound: false,
      document: {},
      datesData: {},

      staffPickerParams: {},
      timePickerParams: {},
    };
  }

  init() {
    this.setState({
      datesData: {
        clients: {},
        dates: [],
        schedules: {},
      },
    });
  }

  componentDidMount() {
    this.init();
    this.loadReferences().then(() => this.load());
    this.renderButtons();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.documentId !== this.props.documentId) {
      this.load();
    }
    this.renderButtons();
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { document } = state;
      document[id] = value;
      return { document };
    });
  };

  onChangeDates = (id, value) => {
    this.setState(
      (state) => {
        let { document } = state;
        document[id] = value;
        return { document };
      },
      () => this.updateDates()
    );
  };

  loadReferences = async () => {};

  load = async () => {
    const { documentId } = this.props;
    this.setState({ pending: true, notFound: false });
    if (documentId && documentId !== "add") {
      let document = await this.context.api.q("/timesheet/get", {
        id: documentId,
      });
      if (!document) {
        this.setState({ notFound: true });
      } else {
        let originalDatesData = await this.context.api.qa("/timesheet/date", {
          document: documentId,
        });

        let datesData = timesheetRefactorInData(originalDatesData);

        this.setState({ document, datesData });
      }
    } else {
      this.setState({ document: {} }, () => this.init());
    }
    this.setState({ pending: false });
    this.context.force();
  };

  updateDates = () => {
    let { datefrom, dateto } = this.state.document;
    datefrom = datefrom ? new Date(datefrom) : false;
    dateto = dateto ? new Date(dateto) : false;

    if (!datefrom || !dateto) {
      return;
    }

    let dates = [];
    while (datefrom <= dateto) {
      dates.push(new Date(datefrom).toLocaleDateString());
      datefrom.setDate(datefrom.getDate() + 1);
    }

    this.setState(({ datesData }) => {
      datesData.dates = dates;
      return { datesData };
    });
  };

  save = async () => {
    let documentId = null;

    if (this.props.documentId && this.props.documentId !== "add") {
      documentId = this.props.documentId;
    }

    const { document } = this.state;
    this.setState({ pending: true });
    let saveData = {
      id: documentId,
      description: document.description,
    };
    let result = await this.context.api.q("/timesheet/set", saveData);

    if (result !== false) {
      let saveDates = [];
      const { datesData } = this.state;
      let clients = Object.keys(datesData.clients);
      if (Array.isArray(datesData.dates) && Array.isArray(clients)) {
        datesData.dates.forEach((date) => {
          clients.forEach((client) => {
            let clientSchedule = datesData.schedules[client] || {};
            let schedule = clientSchedule[date] || [];
            saveDates.push({
              date,
              client,
              schedule,
            });
          });
        });
      }

      let saveDatesResult = await this.context.api.q("/timesheet/date", {
        document: result.id,
        dates: saveDates,
      });

      if (saveDatesResult !== false) {
        this.context.toast("Изменения сохранены", "success");
      } else {
        this.context.toast("Не удалось сохранить изменения", "error");
      }
      this.setState({ pending: false });

      if (this.props.documentId === "add") {
        this.context.redirect(`/timesheet/${result.id}`);
      } else {
        if (saveDatesResult !== false) {
          this.load();
        }
      }
    } else {
      this.setState({ pending: false });
      this.context.toast("Не удалось сохранить изменения", "error");
    }
  };

  new = () => {
    this.init();
    this.context.redirect("/timesheet/add");
  };

  open = () => {
    const { documentId } = this.props;
    if (documentId && documentId !== "add") {
      this.context.redirect(`/workdoc/any/any/${documentId}`);
    } else {
      this.context.redirect("/workdoc/");
    }
  };

  renderButtons = () => {
    this.context.actionsSet(
      <>
        <button
          title="Новый"
          onClick={this.new}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-file-o"></i>
        </button>
        <button
          title="Сохранить"
          onClick={this.save}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-save"></i>
        </button>
        <button
          title="Открыть"
          onClick={this.open}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-folder-open-o"></i>
        </button>
      </>
    );
  };

  onStaffPickClose = () => {
    this.setState(({ staffPickerParams }) => {
      staffPickerParams.show = false;
      return { staffPickerParams };
    });
  };

  onStaffPickOpen = () => {
    this.setState(({ staffPickerParams }) => {
      staffPickerParams.show = true;
      return { staffPickerParams };
    });
  };

  onStaffPick = (staffItem = {}) => {
    this.setState(
      ({ datesData }) => {
        datesData.clients[staffItem.id] = {
          fullname: staffItem.fullname,
          positionname: staffItem.positionname,
        };
        return { datesData };
      },
      () => this.onStaffPickClose()
    );
  };

  onStaffAdd = () => {
    this.onStaffPickOpen();
  };

  onStaffRemove = async (clientId = false, client = {}) => {
    if (!clientId) return;
    let result = await this.context.ask(
      `Вы действительно хотите удалить из табеля сотрудника ${client.fullname}?`
    );
    if (!result.value) return;

    this.setState(({ datesData }) => {
      delete datesData.clients[clientId];
      delete datesData.schedules[clientId];
      return { datesData };
    });
  };

  onScheduleRemove = ({ clientId, date, idx }) => {
    this.setState(({ datesData }) => {
      if (datesData.schedules[clientId]) {
        if (Array.isArray(datesData.schedules[clientId][date])) {
          datesData.schedules[clientId][date].splice(idx, 1);
        }
      }
      return { datesData };
    });
  };

  onScheduleChange = ({ clientId, date, idx, period }) => {
    this.setState(({ datesData }) => {
      if (datesData.schedules[clientId]) {
        if (Array.isArray(datesData.schedules[clientId][date])) {
          datesData.schedules[clientId][date].splice(idx, 1, period);
        }
      }

      return { datesData };
    });
  };

  onScheduleAddBegin = ({ clientId, date }) => {
    this.setState({
      timePickerParams: {
        show: true,
        clientId,
        date,
      },
    });
  };

  onScheduleAddEnd = (period = []) => {
    const { clientId, date } = this.state.timePickerParams;

    this.setState(({ datesData }) => {
      if (datesData.schedules[clientId]) {
        if (Array.isArray(datesData.schedules[clientId][date])) {
          datesData.schedules[clientId][date].push(period);
        } else {
          datesData.schedules[clientId][date] = [period];
        }
      } else {
        datesData.schedules[clientId] = {
          [date]: [period],
        };
      }

      return { datesData, timePickerParams: { show: false } };
    });
  };

  onScheduleAddCancel = () => {
    this.setState({ timePickerParams: { show: false } });
  };

  render() {
    const { document, notFound, pending, datesData = {} } = this.state;
    const { staffPickerParams = {}, timePickerParams = {} } = this.state;

    const { documentId } = this.props;
    let title = documentId === "add" ? "Новый табель" : document.label;

    let readOnly = false;

    if (notFound) {
      title = "Документ не найден";
      return (
        <div className="container">
          <CrumbsProvider title={title} />
          <DefaultNotFound />
        </div>
      );
    }

    return (
      <>
        {timePickerParams.show && (
          <TimePeriodPicker
            title="Добавление периода"
            onChange={this.onScheduleAddEnd}
            onClose={this.onScheduleAddCancel}
          />
        )}
        <StaffPicker
          listKey={staffPickerParams.listKey}
          onPick={this.onStaffPick}
          onClose={this.onStaffPickClose}
          show={staffPickerParams.show}
          keepModal
        />
        <CrumbsProvider title={title} link={`/timesheet/${documentId}/`} />
        <div className="container h-100">
          <div className="row  h-100">
            <div className="col">
              <Blocker on={pending}>
                <div className="card card-custom card-stretch">
                  <div className="card-body px-5 py-5">
                    <div className="dochat">
                      <div className="flex-grow-1">
                        <div className="row">
                          <div className="col-6">
                            <FormLine label="Начало периода:">
                              <DtPicker
                                isClearable
                                onChange={(v) =>
                                  this.onChangeDates("datefrom", v)
                                }
                                value={document.datefrom}
                              />
                            </FormLine>
                          </div>
                          <div className="col-6">
                            <FormLine label="Окончание периода:">
                              <DtPicker
                                isClearable
                                onChange={(v) =>
                                  this.onChangeDates("dateto", v)
                                }
                                value={document.dateto}
                              />
                            </FormLine>
                          </div>
                          <div className="col-12 mt-4">
                            <FormLine label="Комментарий:">
                              <ElasticInput
                                rows={1}
                                value={document.description || ""}
                                onChange={(e) =>
                                  this.onChange("description", e.target.value)
                                }
                                className="form-control"
                              />
                            </FormLine>
                          </div>
                        </div>
                      </div>

                      {document.id && (
                        <div className="d-flex align-items-center ml-3">
                          <EssenceStateLabel
                            onAfterStateChanged={(c) => {
                              if (c === "enabled") {
                                this.open();
                              }
                            }}
                            id={document.id}
                            stateCode={document.statetypecode}
                            stateLabel={document.statelabel}
                            essence="timesheet"
                          />
                          <EssenceActionsDropdown
                            essence={"timesheet"}
                            key={document.id}
                            id={document.id}
                            label={document.label}
                            onFinish={this.load}
                          />
                        </div>
                      )}
                    </div>

                    <TimesheetTable
                      onScheduleRemove={this.onScheduleRemove}
                      onScheduleChange={this.onScheduleChange}
                      onScheduleAdd={this.onScheduleAddBegin}
                      onStaffRemove={this.onStaffRemove}
                      onStaffAdd={this.onStaffAdd}
                      datesData={datesData}
                      readOnly={readOnly}
                    />
                  </div>
                </div>
              </Blocker>
            </div>
          </div>
        </div>
      </>
    );
  }
}
